<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { Aside as AppAside } from '@coreui/vue'
import { authComputed } from '@state/helpers'

export default {
  components: {
    VuePerfectScrollbar,
    AppAside,
  },

  computed: {
    ...authComputed,

    name() {
      return this.$route.name
    },

    list() {
      return this.$route.matched.filter((route) => route.name || route.meta.label)
    },

    psSettings: function() {
      return {
        maxScrollbarLength: 200,
        minScrollbarLength: 40,
        scrollYMarginOffset: 0,
      }
    },
  },
}
</script>

<template>
  <div>
    <div v-if="loggedInToken" class="app">
      <BaseNavBar />

      <div class="app-body">
        <BaseNavSide />

        <VuePerfectScrollbar class="scroll-area" :settings="psSettings">
          <main class="main">
            <slot name="header" />
            <div class="container-fluid" style="margin-bottom: 50px;">
              <slot />
            </div>
          </main>
        </VuePerfectScrollbar>

        <!--aside-->
        <AppAside>
          <BaseInfoSide />
        </AppAside>
      </div>
    </div>

    <div v-if="!loggedInToken" class="app">
      <div class="app-body">
        <main class="main">
          <div class="container-fluid">
            <slot />
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.scroll-area {
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>
